module.exports = __webpack_public_path__ + "media/images/front/whistle/dummy-thumbnail-0a637ff107ed929d1169503903ad9d7e.png";